import PowersLogo from '~/assets/drill/powers'
import DrillTopicListElement from '~/components/Drill/DrillTopicsList/components/DrillTopicListElement'

export default function Powers({
  title,
  completed,
  path,
}: {
  title: string
  completed: boolean
  path: string
}): React.ReactElement {
  const gridMobile = 'row-start-7 row-end-9 col-start-2 col-end-4'
  const gridTablet = 'md:row-start-2 md:row-end-2 md:col-start-4 md:col-end-6'
  const gridDesktop = 'xl:row-start-1 xl:row-end-1 xl:col-start-7 xl:col-end-9'
  const gridClassNames = [gridMobile, gridTablet, gridDesktop].join(' ')

  return (
    <DrillTopicListElement
      completed={completed}
      gridClassNames={gridClassNames}
      image={PowersLogo}
      imageClassNames="h-16"
      path={path}
      title={title}
    />
  )
}
